export const SUBSCRIPTION_STATUS_ACTIVE = 'Active';
export const SUBSCRIPTION_STATUS_CANCELLED = 'Cancelled';
export const SUBSCRIPTION_STATUS_PAUSED = 'Paused';
